export default __webpack_public_path__ + "static/media/envibe.55185966.png";